/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Contact_SupportInputs */

const en_admin_dashboard_contact_support = /** @type {(inputs: Admin_Dashboard_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contact support`)
};

const de_admin_dashboard_contact_support = /** @type {(inputs: Admin_Dashboard_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support kontaktieren`)
};

const es_admin_dashboard_contact_support = /** @type {(inputs: Admin_Dashboard_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contáctanos`)
};

const fr_admin_dashboard_contact_support = /** @type {(inputs: Admin_Dashboard_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contacter notre service d'assistance`)
};

const it_admin_dashboard_contact_support = /** @type {(inputs: Admin_Dashboard_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contatta il supporto`)
};

const pt_br2_admin_dashboard_contact_support = /** @type {(inputs: Admin_Dashboard_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`entre em contato com o suporte`)
};

const pl_admin_dashboard_contact_support = /** @type {(inputs: Admin_Dashboard_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`skontaktuj się z pomocą techniczną`)
};

const hu_admin_dashboard_contact_support = /** @type {(inputs: Admin_Dashboard_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lépjen kapcsolatba az ügyfélszolgálattal`)
};

const ro_admin_dashboard_contact_support = /** @type {(inputs: Admin_Dashboard_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contactati suportul`)
};

/**
* | output |
* | --- |
* | "contact support" |
*
* @param {Admin_Dashboard_Contact_SupportInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_contact_support = /** @type {((inputs?: Admin_Dashboard_Contact_SupportInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Contact_SupportInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_contact_support(inputs)
	if (locale === "de") return de_admin_dashboard_contact_support(inputs)
	if (locale === "es") return es_admin_dashboard_contact_support(inputs)
	if (locale === "fr") return fr_admin_dashboard_contact_support(inputs)
	if (locale === "it") return it_admin_dashboard_contact_support(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_contact_support(inputs)
	if (locale === "pl") return pl_admin_dashboard_contact_support(inputs)
	if (locale === "hu") return hu_admin_dashboard_contact_support(inputs)
	return ro_admin_dashboard_contact_support(inputs)
});
export { admin_dashboard_contact_support as "admin.dashboard.contact_support" }